import { render, staticRenderFns } from "./teacherAdministrator.vue?vue&type=template&id=f120c980"
import script from "./teacherAdministrator.vue?vue&type=script&lang=js"
export * from "./teacherAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports